import styled, { css } from 'styled-components';
import { Button, IconButton, Label } from '../../../Components/uielements';
import { key, palette } from 'styled-theme';
import InfoIcon from '@mui/icons-material/Info';

export const HeaderButtonWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  gap: 15px;
`;

export const MapSearchInput = styled.input`
  position: absolute;
  left: 38%;
  top: 14px;
  border-radius: 10px;
  padding: 8px 20px;
  border: none;
`;

export const MapButton = styled(IconButton)`
  position: absolute;
  right: 33%;
  top: 14px;
  padding: 6px 20px;
  ${(props) =>
    props.color === 'error' &&
    css`
      background-color: ${palette('error', 0)};
      padding: 8px 20px;
      right: 37%;
      color: #fff;
    `}
`;

export const StyledContainer = styled.div`
  display: grid;
  gap: ${key('sizes.gap.medium', '20px')};
`;

export const MapLabel = styled(Label)``;

export const MapCard = styled.div`
  position: absolute;
  left: 5px;
  top: 60px;
  margin-left: 5px;
  background-color: ${palette('background', 0)};
  padding: 20px 30px 20px 20px;
  box-shadow: 0px 4px 30px ${palette('shadow', 1)};
  border-radius: 5px;
  max-height: 450px;
  overflow: auto;
  scroll-behavior: smooth;
`;
export const MapCardContent = styled.div`
  display: grid;
  grid-auto-flow: row;
  position: relative;
  gap: 8px;
  ${(props) =>
    props.isGap &&
    css`
      gap: 25px;
    `}
`;
export const MapCardActions = styled.div`
  padding-top: ${key('sizes.gutter.custom', '15px')};
  display: grid;
  grid-auto-flow: column;
`;

export const MapCardActionsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  margin-top: -15px;
`;

export const TextButton = styled(Button)`
  min-width: fit-content;
  cursor: pointer;
  margin-left: 5px;
`;

export const OutlineButton = styled(Button)`
  background: transparent !important;
  border: 1.5px solid ${palette('gray', 0)};
  background: ${palette('background', 1)};
  min-width: fit-content;
  color: ${palette('text', 1)} !important;
  &:hover {
    background: ${palette('background', 2)} !important;
    color: ${palette('text', 0)} !important;
    border: none !important;
  }
`;

export const MapHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MapHeaderTitle = styled(Label)`
  word-wrap: break-word;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;

  font-weight: bold;
  font-size: ${key('sizes.font.big', '16px')};
`;

export const InfoIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

export const StyledInfoIcon = styled(InfoIcon)`
  width: 16px;
  height: 16px;
  color: #fff;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
`;

export const Tooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: #333;
  color: white;
  border-radius: 4px;
  font-size: 0.875rem;
  white-space: normal;
  z-index: 1000;
  transition: all 0.2s ease;
  margin-top: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 150px;
  word-wrap: break-word;

  /* Arrow */
  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 8px;
    height: 8px;
    background-color: #333;
  }
`;

export const AddGeofenceInfoBanner = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  background: #1f2a4a;
  color: #ffffff;

  padding: 14px 16px;
  margin-bottom: 16px;

  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
`;

export const InfoText = styled.div`
  font-size: 14px;
  line-height: 1.4;
  width: 250px;
`;

export const CloseIcon = styled.span`
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;
